////////LIBRARY/////////
import { isUndefined } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, telecollectManagerActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getTelecollects = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_TELECOLLECTS(user['idUser'], payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(telecollectManagerActionCreators.getTelecollectsSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(telecollectManagerActionCreators.getTelecollectsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getDetailHeader = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_TELECOLLECT_HEADER(payload.idTelecollect)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, payload.bodyMsg)

		yield put(telecollectManagerActionCreators.getDetailHeaderSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(telecollectManagerActionCreators.getDetailHeaderFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getTelecollectTicket = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.GET_TELECOLLECT_TICKET(payload.idTelecollect)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(telecollectManagerActionCreators.getTelecollectTicketSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(telecollectManagerActionCreators.getTelecollectTicketFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getDetailItems = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)

	let data = {
		included: {},
		excluded: {},
	}

	//const apiCall       = R.GET_TELECOLLECT_DETAIL_ITEMS(payload.idTelecollect,payload.mode);
	yield put(globalLoadingActionCreators.startLoading())

	try {
		if (isUndefined(payload.mode) || payload.mode === 'included') {
			const apiCall = R.GET_TELECOLLECT_DETAIL_ITEMS(payload.idTelecollect, 'included')
			const dataIncluded = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

			data.included = dataIncluded
		}

		if (isUndefined(payload.mode) || payload.mode === 'excluded') {
			const apiCall = R.GET_TELECOLLECT_DETAIL_ITEMS(payload.idTelecollect, 'excluded')
			const dataIncluded = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

			data.excluded = dataIncluded
		}
		//const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(telecollectManagerActionCreators.getDetailItemsSuccess(data, payload.mode))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(telecollectManagerActionCreators.getDetailItemsFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getDetailSale = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const bodyMsg = payload.filters

	const apiCall = R.GET_TELECOLLECT_DETAIL_SALE(payload.idTelecollect, payload.idSale)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(telecollectManagerActionCreators.getDetailSaleSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(telecollectManagerActionCreators.getDetailSaleFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const setTelecollectComparison = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.SET_TELECOLLECT_COMPARISON(payload.idTelecollect)
	const bodyMsg = payload.filters

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bodyMsg)

		yield put(telecollectManagerActionCreators.setTelecollectComparisonSuccess(data.data))

		yield put(
			toastSuccessActionCreators.hydrateToast(
				'toast__paymentCollectionManagement__detail__comparison_validation_message',
				uriList.sales + uriList.telecollectManager
			)
		)
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(telecollectManagerActionCreators.setTelecollectComparisonFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_TELECOLLECTS, getTelecollects)
	yield takeLatest(ActionsTypes.GET_TELECOLLECT_HEADER, getDetailHeader)
	yield takeLatest(ActionsTypes.GET_TELECOLLECT_TICKET, getTelecollectTicket)
	yield takeLatest(ActionsTypes.GET_TELECOLLECT_DETAIL_ITEMS, getDetailItems)
	yield takeLatest(ActionsTypes.GET_TELECOLLECT_DETAIL_SALE, getDetailSale)
	yield takeLatest(ActionsTypes.SET_TELECOLLECT_COMPARISON, setTelecollectComparison)
}

export default sagas
